/* eslint-disable no-unused-vars */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

const slides = [
  "./images/image8.jpg",
  "./images/image21.jpg",
  "./images/image24.jpg",
  "./images/image14.jpg",
  "./images/image30.jpg",
  "./images/image32.jpg",
];

export default function HeroSlider() {
  return (
    <section className="relative h-[70vh] w-full">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        pagination={{ clickable: true }}
        className="h-full"
      >
        {slides.map(src => (
          <SwiperSlide key={src} className="h-full">
            <img src={src} alt="" className="h-full w-full object-cover" />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* <div className="absolute inset-0 z-10 bg-gradient-to-b
                  from-black/60 via-black/20 to-black/60 pointer-events-none" />

      <div className="absolute inset-0 z-20 flex flex-col items-center
                  justify-center px-4 text-center text-white">
        <h1 className="mb-6 max-w-4xl text-4xl font-extrabold tracking-tight
                      drop-shadow md:text-5xl">
          A bennünk élő hagyomány<br className="hidden md:block" />
          – Balaton&nbsp;Táncegyüttes
        </h1>

        <Link
          to="/support"
          className="rounded-md bg-primary px-8 py-3 text-lg font-semibold
                    shadow-lg transition hover:bg-primary/90"
        >
          Csatlakozz támogatóinkhoz
        </Link>
      </div> */}
    </section>
  );
}
